import { useMemo } from 'react';
import { readRemoteConfigFlags, type RemoteConfigFlags } from '../services/firebase/remoteConfigFlags';

export type { RemoteConfigFlags };

/** Snapshot of Remote Config flags (fetched at bootstrap). */
export function useRemoteConfig(): RemoteConfigFlags {
  return useMemo(() => readRemoteConfigFlags(), []);
}
